import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });


// $('.trigger').on({
//   mouseenter: function () {
//     gsap.to($(this).siblings('.mega-menu'), {
//       duration: 0.3,
//       autoAlpha: 1
//     });
//   },
//   mouseleave: function (e) {
//     // マウスが.mega-menuに移動した場合はアニメーションを維持
//     if (!$(e.relatedTarget).closest('.mega-menu').length) {
//       gsap.to($(this).siblings('.mega-menu'), {
//         duration: 0.1,
//         autoAlpha: 0
//       });
//     }
//   }
// });

// // .mega-menuからマウスが離れた時の処理
// $('.mega-menu').on('mouseleave', function () {
//   gsap.to(this, {
//     duration: 0.1,
//     autoAlpha: 0
//   });
// });


// メガメニューを開く関数
const openMegaMenu = (target) => {
  gsap.to($(target).siblings('.mega-menu'), {
    duration: 0.3,
    autoAlpha: 1,
    height: 'auto',
    ease: 'power2.out'
  });
};

// メガメニューを閉じる関数
const closeMegaMenu = (target) => {
  gsap.to($(target).siblings('.mega-menu'), {
    duration: 0.3,
    autoAlpha: 0,
    height: 0,
    ease: 'power2.in'
  });
};

// サブメニューを開く関数
const openSubMenu = (target) => {
  $(target).siblings('.group-child').slideDown(300);
  $(target).addClass('is-active');
};

// サブメニューを閉じる関数
const closeSubMenu = (target) => {
  $(target).siblings('.group-child').slideUp(300);
  $(target).removeClass('is-active');
};

// レスポンシブ対応のイベントハンドラー設定
const setMenuHandlers = () => {
  // 初期状態ですべてのメガメニューを閉じた状態に
  gsap.set('.mega-menu', {
    autoAlpha: 0,
    height: 0
  });

  // 既存のイベントハンドラーを削除
  $('.trigger').off();
  $('.mega-menu').off();
  $('.komidashi').off();

  if (window.matchMedia('(min-width: 769px)').matches) {
    // PC向けの処理
    // メガメニューのマウスオーバー処理
    $('.trigger').on({
      mouseenter: function () {
        openMegaMenu(this);
      },
      mouseleave: function (e) {
        if (!$(e.relatedTarget).closest('.mega-menu').length) {
          closeMegaMenu(this);
        }
      }
    });

    $('.mega-menu').on('mouseleave', function () {
      gsap.to(this, {
        duration: 0.2,
        autoAlpha: 0,
        height: 0,
        ease: 'power2.in'
      });
    });

    // PCサイズではサブメニューを常に表示
    $('.group-child').show();

  } else {
    // モバイル向けの処理
    // メガメニューのクリック処理
    $('.trigger').on('click', function (e) {
      e.preventDefault();
      const megaMenu = $(this).siblings('.mega-menu');
      const isVisible = gsap.getProperty(megaMenu[0], 'opacity') === 1;
      $('.trigger').not(this).removeClass('is-active');
      // 開いているメガメニューを閉じる
      $('.mega-menu').each(function () {
        gsap.to(this, {
          duration: 0.2,
          autoAlpha: 0,
          height: 0,
          ease: 'power2.inout'
        });
      });

      // クリックしたメニューが閉じていた場合は開く
      if (!isVisible) {
        openMegaMenu(this);
        $(this).addClass('is-active');
      } else {
        $(this).removeClass('is-active');
      }
    });

    // サブメニューのクリック処理
    $('.group-child').hide(); // 初期状態で非表示

    $('.komidashi').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // メガメニューのクリックイベントが発火するのを防ぐ

      const $otherKomidashi = $('.komidashi').not(this);

      // 他のサブメニューを閉じる
      closeSubMenu($otherKomidashi);

      // クリックされたサブメニューをトグル
      const $groupChild = $(this).siblings('.group-child');
      if ($groupChild.is(':visible')) {
        closeSubMenu(this);
      } else {
        openSubMenu(this);
      }
    });

    // モバイルでは画面外クリックでメニューを閉じる
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.trigger, .mega-menu').length) {
        $('.mega-menu').each(function () {
          gsap.to(this, {
            duration: 0.2,
            autoAlpha: 0,
            height: 0,
            ease: 'power2.in'
          });
        });
      }
    });
  }
};

// 初期化時に実行
setMenuHandlers();

// ウィンドウリサイズ時にイベントハンドラーを再設定
let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    setMenuHandlers();
  }, 250);
});


// aタグのクリック処理を追加
$('.mega-menu a').on('click', function (e) {
  // アンカーリンクの動作は維持
  const href = $(this).attr('href');
  if (href !== 'javascript:void(0);') {
    // メガメニューを閉じる
    $('.mega-menu').each(function () {
      gsap.to(this, {
        duration: 0.2,
        autoAlpha: 0,
        height: 0,
        ease: 'power2.in'
      });
    });
    // triggerのアクティブ状態を解除
    $('.trigger').removeClass('is-active');
    // サブメニューを閉じる
    $('.group-child').slideUp(300);
    $('.komidashi').removeClass('is-active');
  }
});
